// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OdXw2{margin-bottom:8px;width:100%;box-sizing:border-box}.KKzcn{flex-shrink:0}.J5Xka{flex:1;min-width:0;overflow:hidden}.g3llW{display:flex;min-width:0;align-items:baseline;gap:4px;padding:4px 0}.yq3VS{margin-bottom:0}.yq3VS .g3llW{--font-size-p2: var(--font-size-p1, 14px);--line-height-p2: var(--line-height-p1, 22px);padding:2px 0}.IE2fv{flex-shrink:0}.am3nB{justify-content:space-between}._ajYE{flex-direction:column;align-items:flex-start;gap:0}.DIyB5{font-weight:600}.Duraa{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.am3nB .Duraa{flex:unset}.Duraa.QBE2T{flex:0 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mkINj{flex-shrink:0}.g_8OC{display:flex;justify-content:flex-start;padding-top:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `OdXw2`,
	"actions": `KKzcn`,
	"rowBeforeActions": `J5Xka`,
	"cardRow": `g3llW`,
	"list": `yq3VS`,
	"cardRowLabel": `IE2fv`,
	"spaceBetween": `am3nB`,
	"stacked": `_ajYE`,
	"strong": `DIyB5`,
	"cardRowValue": `Duraa`,
	"withInlineItems": `QBE2T`,
	"cardRowInline": `mkINj`,
	"footer": `g_8OC`
};
export default ___CSS_LOADER_EXPORT___;
